export function headerMenuSlider() {
    if (window.innerWidth >= 1200) {
        $('.header-menu-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: false
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerMenuSlider.js